import AccountVerificationContainer from './container/AccountVerificationContainer';

export default AccountVerificationContainer;
